<div class="main-nav__item" role="button">
  <div class="main-nav-expanded--visible main-nav__toggle--collapse">
    <div class="portal-version">
      <span>v{{ currentPortalVersion }}</span>
    </div>

    <div>
      <span>{{ 'menu.toggle.collapse' | portalTranslate }}</span>

      <i class="far fa-angle-double-left ms-1"></i>
    </div>
  </div>

  <div class="main-nav-expanded--hidden main-nav__toggle--expand">
    <i class="far fa-angle-double-right ms-1"></i>
  </div>
</div>
